import { createSelector } from 'reselect';

const selectRoutePoints = (state: any) => state.routePoints;


export const selectRoutePointsCurrentItem = createSelector([selectRoutePoints], (routePoints) => routePoints.current);

export const selectRoutePointsListItems = createSelector([selectRoutePoints], (routePoints) => routePoints.list);

export const selectRoutePointsItemById = (itemId: any) =>
    createSelector(selectRoutePointsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRoutePointsQueryItems = createSelector([selectRoutePoints], (routePoints) => routePoints.query);


export const selectRoutePointsCreatedItem = createSelector([selectRoutePoints], (routePoints) => routePoints.create);

export const selectRoutePointsUpdatedItem = createSelector([selectRoutePoints], (routePoints) => routePoints.update);

export const selectRoutePointsReadItem = createSelector([selectRoutePoints], (routePoints) => routePoints.read);

export const selectRoutePointsDeletedItem = createSelector([selectRoutePoints], (routePoints) => routePoints.delete);

export const selectRoutePointsSearchedItems = createSelector([selectRoutePoints], (routePoints) => routePoints.search);

export const selectRoutePointsItemsCount = createSelector([selectRoutePoints], (routePoints) => routePoints.count);

export const selectRoutePointsItemsFilter = createSelector([selectRoutePoints], (routePoints) => routePoints.filter);